export const DISABLE_SERVER_STATUS_BUTTON_STATUSES = [
  'failed_start',
  'decom',
  'pending_start',
  'start',
  'pending_stop',
  'stop',
  'pending_reboot_soft',
  'reboot_soft',
  'deleted',
  'failed_stop',
  'pending_postprov',
  'pending_create',
  'create',
  'pending_build',
  'build',
  'postprov',
  'pending_rebuild',
  'rebuild',
];
